import { createApi } from "@reduxjs/toolkit/query/react";
import { appBaseQuery } from "config/api.config";
import { MonitoringData } from "types/monitoring.types";

export const monitoringApi = createApi({
  reducerPath: "statistics",
  baseQuery: appBaseQuery,
  endpoints: (builder) => ({
    getMonitoringData: builder.query<MonitoringData, void>({
      query: () => ({
        url: "Statistics/GetMonitoringData",
      }),
    }),
  }),
});

export const { useGetMonitoringDataQuery } = monitoringApi;
